import { useMemo, useState } from "react";

type PokeInfo = {
  pokeAbility: string;
  pokeForm: string;
  pokeMove: string;
  pokeName: string;
  pokeSpecies: string;
  pokeStatNumber: number;
  pokeStatName: string;
  pokeType: string;
};
type PokeImg = {
  img: string;
  imgBack: string;
};

const usePokeInfoModal = (
  id: number
): readonly [
  PokeInfo | undefined,
  string | undefined,
  string | undefined,
  string | undefined,
  PokeImg | undefined,
  boolean
] => {
  const [pokeDetalles, setPokeDetalles] = useState<PokeInfo>();
  const [pokeColor, setPokeColor] = useState<string>();
  const [pokeLocation, setPokeLocation] = useState<string>();
  const [pokeCategory, setPokeCategory] = useState<string>();
  const [pokeImg, setPokeImg] = useState<PokeImg>();
  const [loading, setLoading] = useState<boolean>(false);

  const getPokemonDetails = async (pokeId: number) => {
    const res = await fetch(`https://pokeapi.co/api/v2/pokemon/${pokeId}`);
    const resultado = await res.json();
    setPokeDetalles({
      pokeAbility: resultado.abilities[0].ability.name,
      pokeForm: resultado.forms[0].name,
      pokeMove: resultado.moves[0].move.name,
      pokeName: resultado.name,
      pokeSpecies: resultado.species.name,
      pokeStatNumber: resultado.stats[0].base_stat,
      pokeStatName: resultado.stats[0].stat.name,
      pokeType: resultado.types[0].type.name
    });
  };

  const getPokemonColor = async (idColor: number) => {
    const res = await fetch(
      `https://pokeapi.co/api/v2/pokemon-species/${idColor}/`
    );
    const resultado = await res.json();
    setPokeColor(resultado.color.name);
  };

  const getPokemonLocation = async (idLocation: number) => {
    const res = await fetch(
      `https://pokeapi.co/api/v2/location/${idLocation}/`
    );
    const resultado = await res.json();
    setPokeLocation(resultado.name);
  };

  const getPokemonCategory = async (idCategory: number) => {
    const res = await fetch(`https://pokeapi.co/api/v2/item/${idCategory}/`);
    const resultado = await res.json();
    setPokeCategory(resultado.category.name);
  };

  const getPokemonImg = async (idImg: number) => {
    const res = await fetch(`https://pokeapi.co/api/v2/pokemon/${idImg}`);
    const resultado = await res.json();
    await getPokemonColor(resultado.id);
    setPokeImg({
      img: resultado.sprites.front_default,
      imgBack: resultado.sprites.back_default
    });
  };

  useMemo(async () => {
    setLoading(true);
    await getPokemonDetails(id);
    await getPokemonColor(id);
    await getPokemonCategory(id);
    getPokemonLocation(id);
    await getPokemonImg(id);
    setLoading(false);
  }, [id]);

  return [
    pokeDetalles,
    pokeColor,
    pokeCategory,
    pokeLocation,
    pokeImg,
    loading
  ] as const;
};

export default usePokeInfoModal;
